
import PageTitle from "../../components/PageTitle.vue";

export default {
	components: { PageTitle },
	data() {
		return {
			cargar:false,
			title: "Listado de Usuarios",
			titleForm: "Usuario",
			totalRows: 1,
			currentPage: 1,
			perPage: 20,
			fields: [
				{ key: "acciones", 		label: "Acciones",	sortable: false },
				{ key: "user", 			label: "Usuario", 	sortable: true },
				{ key: "fullnamedoc", 	label: "Personal", 	sortable: true },
				{ key: "rols", 			label: "Rols", 		sortable: true },
				{ key: "sedes", 		label: "Sedes", 	sortable: true },
				{ key: "estado", 		label: "Estado", 	sortable: true }],
			items: [],
			filter: null,
			personals: [],
			sedes: [],
			rols: [],
			form: {
				user: "",
				password: "",
				personal_id: "",
				sedes: [],
				rols: []
			},
		};
	},
	computed: {
		sortOptions() {
			// Create an options list from our fields
			return this.fields
				.filter((f) => f.sortable)
				.map((f) => {
					return { text: f.label, value: f.key };
				});
		},
	},
	methods: {
		async init(){
			this.listar();
			let resp = { data:null}
			try {
				resp = await this.axios.get('select/personals');
				this.personals = resp.data;	

				resp = await this.axios.get('select/sedes');
				this.sedes = resp.data;	

				resp = await this.axios.get('select/rols');
				this.rols = resp.data;	
			} catch (error) {
				console.log(error);
			}
		},
		async listar(){
			try {
				let {data} = await this.axios.get('users');
				this.items = data;	
				this.totalRows = this.items.length;	
			} catch (error) {
				this.catchAction(error);
			}
		},
		async show(id = 0){
			this.cargar = false;
			try {
				this.reset();
				if(id > 0){
					let {data} = await this.axios.get('users/' + id);
					this.form = data;
				}
				// @ts-ignorecls
				$(".modal").modal({backdrop: 'static', keyboard: false})
			} catch (error) {
				this.catchAction(error);
			}	
		},
		async state(item, state){
			let title = 'Activar?';
			let confirmButtonText = 'Si, Activar.';
			if(state == 0){
				title = 'Desactivar?';
				confirmButtonText = 'Si, Desactivar.';
			}

			this.$swal.fire({
				title: title,
				text: item.nombre,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				cancelButtonText: 'Cancelar',
				confirmButtonText: confirmButtonText,
				showLoaderOnConfirm: true,
				preConfirm: (login) => {
					return this.axios.patch('users/' + item.id+'/state',{isActive: state})
					.then((result) => {
						return result.data;
					}).catch((err) => {
						this.$swal.showValidationMessage(
							`Request failed: ${err}`
						)
					});
				},
				allowOutsideClick: () => !this.$swal.isLoading()
			}).then((result) => {
				if (result.isConfirmed) {	
					this.$swal.fire(
						'Estado',
						result.value.msg,
						'success'
					)
					this.listar();
				}
			});
		},
		async clave(item, state){
			this.$swal.fire({
				title: 'Resetear clave?',
				text: item.nombre,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				cancelButtonText: 'Cancelar',
				confirmButtonText: 'Si, resetear (123456789)',
				showLoaderOnConfirm: true,
				preConfirm: (login) => {
					return this.axios.patch('users/' + item.id+'/reset', item)
					.then((result) => {
						return result.data;
					}).catch((err) => {
						this.$swal.showValidationMessage(
							`Request failed: ${err}`
						)
					});
				},
				allowOutsideClick: () => !this.$swal.isLoading()
			}).then((result) => {
				if (result.isConfirmed) {	
					this.$swal.fire(
						'Estado',
						result.value.msg,
						'success'
					)
					this.listar();
				}
			});
		},
		reset(){
			this.form = {
				user: "",
				password: "",
				personal_id: "",
				sedes: [],
				rols: []
			}
		},
		async submit(e){
			e.preventDefault();
			let data:any = '';
			this.cargar = true;
			try {
				if(this.form.id > 0){
					let resp 	= await this.axios.put('users/' + this.form.id, this.form);
					data		= resp.data;
				}else{
					let resp 	= await this.axios.post('users', this.form);
					data		= resp.data;
				}
				this.listar();
			    this.cargar = false;
				// @ts-ignore
				$(".modal").modal('hide');
				// @ts-ignore
				new PNotify({
								text: data.msg,
								type: 'success',
								styling: 'bootstrap3'
							});
			} catch (error) {
				this.cargar = false;
				this.catchAction(error);
			}
		},
		onFiltered(filteredItems) {
			// Trigger pagination to update the number of buttons/pages due to filtering
			this.totalRows = filteredItems.length;
			this.currentPage = 1;
		},
	},
	mounted() {
		// Set the initial number of items
		this.init();
	},
};
